import { CheckVerificationTokenResponse, CheckVerificationTokenInput } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import authService from '../../services/auth.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { CustomerLookupMachineContext } from '../../state-machine/types/customerLookupMachine.types';

const checkCode = async (context: CustomerLookupMachineContext, event: any): Promise<CheckVerificationTokenResponse> => {
  try {
    var input: CheckVerificationTokenInput = {
      cellPhone: context.cellPhone,
      orderId: context.orderId,
      token: event.data?.code,
    };
    const resp = await authService.checkVerificationToken(input);
    return resp.data?.checkVerificationToken as CheckVerificationTokenResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default checkCode;
